import {Modal} from 'antd';
import {FaRegListAlt} from 'react-icons/fa';
import IntlMessages from '../../../../../../domain/utility/IntlMessages';
import {useDispatch, useSelector} from 'react-redux';
import {
  countryRegionId,
  isRegionModalOpened,
} from '../../../redux/country-selectors';
import {openRegionModal, setCountryRegionId} from '../../../redux/countrySlice';
import RegionForm from './RegionForm';

const RegionModal = () => {
  const open = useSelector(isRegionModalOpened);
  const regionId = useSelector(countryRegionId);
  const dispatch = useDispatch();

  return (
    <Modal
      className='add-info-modal'
      width={'700px'}
      open={open || !!regionId}
      maskClosable={false}
      destroyOnClose
      title={
        <>
          <div className='text-title'>
            <span className='icon-title'>
              <FaRegListAlt />
            </span>
            <IntlMessages id='productAttributes.productAttributesPredefinedValues.editValueTitleModal' />
          </div>
        </>
      }
      onCancel={() => {
        dispatch(openRegionModal());
        dispatch(setCountryRegionId(null));
      }}
      footer={false}>
      <RegionForm />
    </Modal>
  );
};

export default RegionModal;
